export class MembroDto {
  proprietarioId: string;
  proprietarioCadastroId: string;
}
